import { ModalFooterButton } from '@/components/Modal'
import { useTexts } from '../../../useTexts'
import { useControllerActions } from '../../../hooks/useControllerActions'

export function ButtonExportAndDeleteOrders() {
  const texts = useTexts()
  const handlers = useControllerActions()

  return (
    <ModalFooterButton
      testid="modal-primary-button"
      title={texts.buttonExportAndDeleteOrders}
      variant="contained"
      onClick={handlers.onExportAndDeleteOrdersButtonClick}
    >
      {texts.buttonExportAndDeleteOrders}
    </ModalFooterButton>
  )
}
